import { delay } from 'rxjs';
import { AuthService } from './AuthService';
import { DevicesService } from './DevicesService';
import { LanguageService } from './LanguageService';
import { NotificationService } from './NotificationService';
import { SettingsWebportalService } from './SettingsWebportalService';
import { ThemeService } from './ThemeService';
import { UserService } from './UserService';
import { WebSocketService } from './WebSocketService';
import { ProductionOverviewService } from './ProductionOverviewService';
import { PlatformService } from './PlatformService';
import { CoreService } from './CoreService';
import { TourService } from './TourService';

class ServiceBundler {
  public themeService;

  public platformService;
  public coreService;
  public tourService;
  
  public languageService;
  public userService;
  public notificationService;
  public devicesService;
  public settingsWebportalService;
  public productionOverviewService;

  constructor() {
    this.themeService = new ThemeService();

    this.coreService = new CoreService();
    this.tourService = new TourService();
    this.languageService = new LanguageService();
    this.notificationService = new NotificationService();

    this.platformService = new PlatformService();
    this.userService = new UserService();
    this.settingsWebportalService = new SettingsWebportalService();
    this.devicesService = new DevicesService();
    this.productionOverviewService = new ProductionOverviewService();
  }
}

export { ServiceBundler };
